const theme = {
  colors: {
    blue: "#5298FF",
    red: "#D55555",
    green: "#49B393",
    grey: "#E4E7EB",
    text: {
      medium: "#717171",
    },
  },
};

export default theme;
